export const COUNTRY_CODES = [
  { label: '🇦🇫 +93', value: '+93', country: 'Afghanistan', isoCode: 'af' },
  { label: '🇦🇱 +355', value: '+355', country: 'Albania', isoCode: 'al' },
  { label: '🇩🇿 +213', value: '+213', country: 'Algeria', isoCode: 'dz' },
  {
    label: '🇦🇸 +1-684',
    value: '+1-684',
    country: 'American Samoa',
    isoCode: 'as',
  },
  { label: '🇦🇩 +376', value: '+376', country: 'Andorra', isoCode: 'ad' },
  { label: '🇦🇴 +244', value: '+244', country: 'Angola', isoCode: 'ao' },
  { label: '🇦🇮 +1-264', value: '+1-264', country: 'Anguilla', isoCode: 'ai' },
  { label: '🇦🇶 +672', value: '+672', country: 'Antarctica', isoCode: 'aq' },
  {
    label: '🇦🇬 +1-268',
    value: '+1-268',
    country: 'Antigua and Barbuda',
    isoCode: 'ag',
  },
  { label: '🇦🇷 +54', value: '+54', country: 'Argentina', isoCode: 'ar' },
  { label: '🇦🇲 +374', value: '+374', country: 'Armenia', isoCode: 'am' },
  { label: '🇦🇼 +297', value: '+297', country: 'Aruba', isoCode: 'aw' },
  { label: '🇦🇺 +61', value: '+61', country: 'Australia', isoCode: 'au' },
  { label: '🇦🇹 +43', value: '+43', country: 'Austria', isoCode: 'at' },
  { label: '🇦🇿 +994', value: '+994', country: 'Azerbaijan', isoCode: 'az' },
  { label: '🇧🇸 +1-242', value: '+1-242', country: 'Bahamas', isoCode: 'bs' },
  { label: '🇧🇭 +973', value: '+973', country: 'Bahrain', isoCode: 'bh' },
  { label: '🇧🇩 +880', value: '+880', country: 'Bangladesh', isoCode: 'bd' },
  { label: '🇧🇧 +1-246', value: '+1-246', country: 'Barbados', isoCode: 'bb' },
  { label: '🇧🇾 +375', value: '+375', country: 'Belarus', isoCode: 'by' },
  { label: '🇧🇪 +32', value: '+32', country: 'Belgium', isoCode: 'be' },
  { label: '🇧🇿 +501', value: '+501', country: 'Belize', isoCode: 'bz' },
  { label: '🇧🇯 +229', value: '+229', country: 'Benin', isoCode: 'bj' },
  { label: '🇧🇲 +1-441', value: '+1-441', country: 'Bermuda', isoCode: 'bm' },
  { label: '🇧🇹 +975', value: '+975', country: 'Bhutan', isoCode: 'bt' },
  { label: '🇧🇴 +591', value: '+591', country: 'Bolivia', isoCode: 'bo' },
  {
    label: '🇧🇦 +387',
    value: '+387',
    country: 'Bosnia and Herzegovina',
    isoCode: 'ba',
  },
  { label: '🇧🇼 +267', value: '+267', country: 'Botswana', isoCode: 'bw' },
  { label: '🇧🇷 +55', value: '+55', country: 'Brazil', isoCode: 'br' },
  {
    label: '🇮🇴 +246',
    value: '+246',
    country: 'British Indian Ocean Territory',
    isoCode: 'io',
  },
  { label: '🇧🇳 +673', value: '+673', country: 'Brunei', isoCode: 'bn' },
  { label: '🇧🇬 +359', value: '+359', country: 'Bulgaria', isoCode: 'bg' },
  { label: '🇧🇫 +226', value: '+226', country: 'Burkina Faso', isoCode: 'bf' },
  { label: '🇧🇮 +257', value: '+257', country: 'Burundi', isoCode: 'bi' },
  { label: '🇰🇭 +855', value: '+855', country: 'Cambodia', isoCode: 'kh' },
  { label: '🇨🇲 +237', value: '+237', country: 'Cameroon', isoCode: 'cm' },
  { label: '🇨🇦 +1', value: '+1-CA', country: 'Canada', isoCode: 'ca' },
  { label: '🇨🇻 +238', value: '+238', country: 'Cape Verde', isoCode: 'cv' },
  {
    label: '🇧🇶 +1-345',
    value: '+1-345',
    country: 'Cayman Islands',
    isoCode: 'ky',
  },
  {
    label: '🇨🇫 +236',
    value: '+236',
    country: 'Central African Republic',
    isoCode: 'cf',
  },
  { label: '🇹🇩 +235', value: '+235', country: 'Chad', isoCode: 'td' },
  { label: '🇨🇱 +56', value: '+56', country: 'Chile', isoCode: 'cl' },
  { label: '🇨🇳 +86', value: '+86', country: 'China', isoCode: 'cn' },
  {
    label: '🇨🇽 +61',
    value: '+61-CX',
    country: 'Christmas Island',
    isoCode: 'cx',
  },
  { label: '🇨🇨 +61', value: '+61-CC', country: 'Cocos Islands', isoCode: 'cc' },
  { label: '🇨🇴 +57', value: '+57', country: 'Colombia', isoCode: 'co' },
  { label: '🇰🇲 +269', value: '+269', country: 'Comoros', isoCode: 'km' },
  { label: '🇨🇬 +242', value: '+242', country: 'Congo', isoCode: 'cg' },
  { label: '🇨🇩 +243', value: '+243', country: 'Congo (DRC)', isoCode: 'cd' },
  { label: '🇨🇰 +682', value: '+682', country: 'Cook Islands', isoCode: 'ck' },
  { label: '🇨🇷 +506', value: '+506', country: 'Costa Rica', isoCode: 'cr' },
  { label: '🇭🇷 +385', value: '+385', country: 'Croatia', isoCode: 'hr' },
  { label: '🇨🇺 +53', value: '+53', country: 'Cuba', isoCode: 'cu' },
  { label: '🇨🇼 +599', value: '+599-CW', country: 'Curaçao', isoCode: 'cw' },
  { label: '🇨🇾 +357', value: '+357', country: 'Cyprus', isoCode: 'cy' },
  { label: '🇨🇿 +420', value: '+420', country: 'Czech Republic', isoCode: 'cz' },
  { label: '🇩🇰 +45', value: '+45', country: 'Denmark', isoCode: 'dk' },
  { label: '🇩🇯 +253', value: '+253', country: 'Djibouti', isoCode: 'dj' },
  { label: '🇩🇲 +1-767', value: '+1-767', country: 'Dominica', isoCode: 'dm' },
  {
    label: '🇩🇴 +1-809',
    value: '+1-809',
    country: 'Dominican Republic',
    isoCode: 'do',
  },
  { label: '🇪🇨 +593', value: '+593', country: 'Ecuador', isoCode: 'ec' },
  { label: '🇪🇬 +20', value: '+20', country: 'Egypt', isoCode: 'eg' },
  { label: '🇸🇻 +503', value: '+503', country: 'El Salvador', isoCode: 'sv' },
  {
    label: '🇬🇶 +240',
    value: '+240',
    country: 'Equatorial Guinea',
    isoCode: 'gq',
  },
  { label: '🇪🇷 +291', value: '+291', country: 'Eritrea', isoCode: 'er' },
  { label: '🇪🇪 +372', value: '+372', country: 'Estonia', isoCode: 'ee' },
  { label: '🇪🇹 +251', value: '+251', country: 'Ethiopia', isoCode: 'et' },
  {
    label: '🇫🇰 +500',
    value: '+500',
    country: 'Falkland Islands',
    isoCode: 'fk',
  },
  { label: '🇫🇴 +298', value: '+298', country: 'Faroe Islands', isoCode: 'fo' },
  { label: '🇫🇯 +679', value: '+679', country: 'Fiji', isoCode: 'fj' },
  { label: '🇫🇮 +358', value: '+358', country: 'Finland', isoCode: 'fi' },
  { label: '🇫🇷 +33', value: '+33', country: 'France', isoCode: 'fr' },
  { label: '🇬🇫 +594', value: '+594', country: 'French Guiana', isoCode: 'gf' },
  {
    label: '🇵🇫 +689',
    value: '+689',
    country: 'French Polynesia',
    isoCode: 'pf',
  },
  {
    label: '🇹🇫 +681',
    value: '+681',
    country: 'French Southern Territories',
    isoCode: 'tf',
  },
  { label: '🇬🇦 +241', value: '+241', country: 'Gabon', isoCode: 'ga' },
  { label: '🇬🇲 +220', value: '+220', country: 'Gambia', isoCode: 'gm' },
  { label: '🇬🇪 +995', value: '+995', country: 'Georgia', isoCode: 'ge' },
  { label: '🇩🇪 +49', value: '+49', country: 'Germany', isoCode: 'de' },
  { label: '🇬🇭 +233', value: '+233', country: 'Ghana', isoCode: 'gh' },
  { label: '🇬🇮 +350', value: '+350', country: 'Gibraltar', isoCode: 'gi' },
  { label: '🇬🇷 +30', value: '+30', country: 'Greece', isoCode: 'gr' },
  { label: '🇬🇱 +299', value: '+299', country: 'Greenland', isoCode: 'gl' },
  { label: '🇬🇩 +1-473', value: '+1-473', country: 'Grenada', isoCode: 'gd' },
  { label: '🇬🇵 +590', value: '+590', country: 'Guadeloupe', isoCode: 'gp' },
  { label: '🇬🇺 +1-671', value: '+1-671', country: 'Guam', isoCode: 'gu' },
  { label: '🇬🇹 +502', value: '+502', country: 'Guatemala', isoCode: 'gt' },
  {
    label: '🇬🇬 +44-1481',
    value: '+44-1481',
    country: 'Guernsey',
    isoCode: 'gg',
  },
  { label: '🇬🇳 +224', value: '+224', country: 'Guinea', isoCode: 'gn' },
  { label: '🇬🇼 +245', value: '+245', country: 'Guinea-Bissau', isoCode: 'gw' },
  { label: '🇬🇾 +592', value: '+592', country: 'Guyana', isoCode: 'gy' },
  { label: '🇭🇹 +509', value: '+509', country: 'Haiti', isoCode: 'ht' },
  {
    label: '🇭🇲 +44',
    value: '+44-HM',
    country: 'Heard and McDonald Islands',
    isoCode: 'hm',
  },
  { label: '🇭🇳 +504', value: '+504', country: 'Honduras', isoCode: 'hn' },
  { label: '🇭🇰 +852', value: '+852', country: 'Hong Kong', isoCode: 'hk' },
  { label: '🇭🇺 +36', value: '+36', country: 'Hungary', isoCode: 'hu' },
  { label: '🇮🇸 +354', value: '+354', country: 'Iceland', isoCode: 'is' },
  { label: '🇮🇳 +91', value: '+91', country: 'India', isoCode: 'in' },
  { label: '🇮🇩 +62', value: '+62', country: 'Indonesia', isoCode: 'id' },
  { label: '🇮🇷 +98', value: '+98', country: 'Iran', isoCode: 'ir' },
  { label: '🇮🇶 +964', value: '+964', country: 'Iraq', isoCode: 'iq' },
  { label: '🇮🇪 +353', value: '+353', country: 'Ireland', isoCode: 'ie' },
  {
    label: '🇮🇲 +44-1624',
    value: '+44-1624',
    country: 'Isle of Man',
    isoCode: 'im',
  },
  { label: '🇮🇱 +972', value: '+972', country: 'Israel', isoCode: 'il' },
  { label: '🇮🇹 +39', value: '+39', country: 'Italy', isoCode: 'it' },
  { label: '🇨🇮 +225', value: '+225', country: 'Ivory Coast', isoCode: 'ci' },
  { label: '🇯🇲 +1-876', value: '+1-876', country: 'Jamaica', isoCode: 'jm' },
  { label: '🇯🇵 +81', value: '+81', country: 'Japan', isoCode: 'jp' },
  { label: '🇯🇪 +44-1534', value: '+44-1534', country: 'Jersey', isoCode: 'je' },
  { label: '🇯🇴 +962', value: '+962', country: 'Jordan', isoCode: 'jo' },
  { label: '🇰🇿 +7', value: '+7-KZ', country: 'Kazakhstan', isoCode: 'kz' },
  { label: '🇰🇪 +254', value: '+254', country: 'Kenya', isoCode: 'ke' },
  { label: '🇰🇮 +686', value: '+686', country: 'Kiribati', isoCode: 'ki' },
  { label: '🇰🇵 +850', value: '+850', country: 'North Korea', isoCode: 'kp' },
  { label: '🇰🇷 +82', value: '+82', country: 'South Korea', isoCode: 'kr' },
  { label: '🇰🇼 +965', value: '+965', country: 'Kuwait', isoCode: 'kw' },
  { label: '🇰🇬 +996', value: '+996', country: 'Kyrgyzstan', isoCode: 'kg' },
  { label: '🇱🇦 +856', value: '+856', country: 'Laos', isoCode: 'la' },
  { label: '🇱🇻 +371', value: '+371', country: 'Latvia', isoCode: 'lv' },
  { label: '🇱🇧 +961', value: '+961', country: 'Lebanon', isoCode: 'lb' },
  { label: '🇱🇸 +266', value: '+266', country: 'Lesotho', isoCode: 'ls' },
  { label: '🇱🇷 +231', value: '+231', country: 'Liberia', isoCode: 'lr' },
  { label: '🇱🇾 +218', value: '+218', country: 'Libya', isoCode: 'ly' },
  { label: '🇱🇮 +423', value: '+423', country: 'Liechtenstein', isoCode: 'li' },
  { label: '🇱🇹 +370', value: '+370', country: 'Lithuania', isoCode: 'lt' },
  { label: '🇱🇺 +352', value: '+352', country: 'Luxembourg', isoCode: 'lu' },
  { label: '🇲🇴 +853', value: '+853', country: 'Macau', isoCode: 'mo' },
  { label: '🇲🇰 +389', value: '+389', country: 'Macedonia', isoCode: 'mk' },
  { label: '🇲🇬 +261', value: '+261', country: 'Madagascar', isoCode: 'mg' },
  { label: '🇲🇼 +265', value: '+265', country: 'Malawi', isoCode: 'mw' },
  { label: '🇲🇾 +60', value: '+60', country: 'Malaysia', isoCode: 'my' },
  { label: '🇲🇻 +960', value: '+960', country: 'Maldives', isoCode: 'mv' },
  { label: '🇲🇱 +223', value: '+223', country: 'Mali', isoCode: 'ml' },
  { label: '🇲🇹 +356', value: '+356', country: 'Malta', isoCode: 'mt' },
  {
    label: '🇲🇭 +692',
    value: '+692',
    country: 'Marshall Islands',
    isoCode: 'mh',
  },
  { label: '🇲🇶 +596', value: '+596', country: 'Martinique', isoCode: 'mq' },
  { label: '🇲🇷 +222', value: '+222', country: 'Mauritania', isoCode: 'mr' },
  { label: '🇲🇺 +230', value: '+230', country: 'Mauritius', isoCode: 'mu' },
  { label: '🇾🇹 +262', value: '+262', country: 'Mayotte', isoCode: 'yt' },
  { label: '🇲🇽 +52', value: '+52', country: 'Mexico', isoCode: 'mx' },
  { label: '🇫🇲 +691', value: '+691', country: 'Micronesia', isoCode: 'fm' },
  { label: '🇲🇩 +373', value: '+373', country: 'Moldova', isoCode: 'md' },
  { label: '🇲🇨 +377', value: '+377', country: 'Monaco', isoCode: 'mc' },
  { label: '🇲🇳 +976', value: '+976', country: 'Mongolia', isoCode: 'mn' },
  { label: '🇲🇪 +382', value: '+382', country: 'Montenegro', isoCode: 'me' },
  { label: '🇲🇸 +1-664', value: '+1-664', country: 'Montserrat', isoCode: 'ms' },
  { label: '🇲🇦 +212', value: '+212', country: 'Morocco', isoCode: 'ma' },
  { label: '🇲🇿 +258', value: '+258', country: 'Mozambique', isoCode: 'mz' },
  { label: '🇲🇲 +95', value: '+95', country: 'Myanmar', isoCode: 'mm' },
  { label: '🇳🇦 +264', value: '+264', country: 'Namibia', isoCode: 'na' },
  { label: '🇳🇷 +674', value: '+674', country: 'Nauru', isoCode: 'nr' },
  { label: '🇳🇵 +977', value: '+977', country: 'Nepal', isoCode: 'np' },
  { label: '🇳🇱 +31', value: '+31', country: 'Netherlands', isoCode: 'nl' },
  { label: '🇳🇿 +64', value: '+64', country: 'New Zealand', isoCode: 'nz' },
  { label: '🇳🇮 +505', value: '+505', country: 'Nicaragua', isoCode: 'ni' },
  { label: '🇳🇪 +227', value: '+227', country: 'Niger', isoCode: 'ne' },
  { label: '🇳🇬 +234', value: '+234', country: 'Nigeria', isoCode: 'ng' },
  { label: '🇳🇺 +683', value: '+683', country: 'Niue', isoCode: 'nu' },
  {
    label: '🇳🇫 +672',
    value: '+672-NF',
    country: 'Norfolk Island',
    isoCode: 'nf',
  },
  {
    label: '🇲🇵 +1-670',
    value: '+1-670',
    country: 'Northern Mariana Islands',
    isoCode: 'mp',
  },
  { label: '🇳🇴 +47', value: '+47', country: 'Norway', isoCode: 'no' },
  { label: '🇴🇲 +968', value: '+968', country: 'Oman', isoCode: 'om' },
  { label: '🇵🇰 +92', value: '+92', country: 'Pakistan', isoCode: 'pk' },
  { label: '🇵🇼 +680', value: '+680', country: 'Palau', isoCode: 'pw' },
  { label: '🇵🇸 +970', value: '+970', country: 'Palestine', isoCode: 'ps' },
  { label: '🇵🇦 +507', value: '+507', country: 'Panama', isoCode: 'pa' },
  {
    label: '🇵🇬 +675',
    value: '+675',
    country: 'Papua New Guinea',
    isoCode: 'pg',
  },
  { label: '🇵🇾 +595', value: '+595', country: 'Paraguay', isoCode: 'py' },
  { label: '🇵🇪 +51', value: '+51', country: 'Peru', isoCode: 'pe' },
  { label: '🇵🇭 +63', value: '+63', country: 'Philippines', isoCode: 'ph' },
  { label: '🇵🇳 +64', value: '+64-PN', country: 'Pitcairn', isoCode: 'pn' },
  { label: '🇵🇱 +48', value: '+48', country: 'Poland', isoCode: 'pl' },
  { label: '🇵🇹 +351', value: '+351', country: 'Portugal', isoCode: 'pt' },
  {
    label: '🇵🇷 +1-787',
    value: '+1-787',
    country: 'Puerto Rico',
    isoCode: 'pr',
  },
  { label: '🇶🇦 +974', value: '+974', country: 'Qatar', isoCode: 'qa' },
  { label: '🇷🇪 +262', value: '+262-RE', country: 'Reunion', isoCode: 're' },
  { label: '🇷🇴 +40', value: '+40', country: 'Romania', isoCode: 'ro' },
  { label: '🇷🇺 +7', value: '+7', country: 'Russia', isoCode: 'ru' },
  { label: '🇷🇼 +250', value: '+250', country: 'Rwanda', isoCode: 'rw' },
  {
    label: '🇧🇱 +1-869',
    value: '+1-869',
    country: 'Saint Barthelemy',
    isoCode: 'bl',
  },
  { label: '🇸🇭 +290', value: '+290', country: 'Saint Helena', isoCode: 'sh' },
  {
    label: '🇰🇳 +1-869',
    value: '+1-869',
    country: 'Saint Kitts and Nevis',
    isoCode: 'kn',
  },
  {
    label: '🇱🇨 +1-758',
    value: '+1-758',
    country: 'Saint Lucia',
    isoCode: 'lc',
  },
  {
    label: '🇲🇫 +590',
    value: '+590-MF',
    country: 'Saint Martin',
    isoCode: 'mf',
  },
  {
    label: '🇵🇲 +508',
    value: '+508',
    country: 'Saint Pierre and Miquelon',
    isoCode: 'pm',
  },
  {
    label: '🇻🇨 +1-784',
    value: '+1-784',
    country: 'Saint Vincent and Grenadines',
    isoCode: 'vc',
  },
  { label: '🇼🇸 +685', value: '+685', country: 'Samoa', isoCode: 'ws' },
  { label: '🇸🇲 +378', value: '+378', country: 'San Marino', isoCode: 'sm' },
  {
    label: '🇸🇹 +239',
    value: '+239',
    country: 'Sao Tome and Principe',
    isoCode: 'st',
  },
  { label: '🇸🇦 +966', value: '+966', country: 'Saudi Arabia', isoCode: 'sa' },
  { label: '🇸🇳 +221', value: '+221', country: 'Senegal', isoCode: 'sn' },
  { label: '🇷🇸 +381', value: '+381', country: 'Serbia', isoCode: 'rs' },
  { label: '🇸🇨 +248', value: '+248', country: 'Seychelles', isoCode: 'sc' },
  { label: '🇸🇱 +232', value: '+232', country: 'Sierra Leone', isoCode: 'sl' },
  { label: '🇸🇬 +65', value: '+65', country: 'Singapore', isoCode: 'sg' },
  {
    label: '🇸🇽 +1-721',
    value: '+1-721',
    country: 'Sint Maarten',
    isoCode: 'sx',
  },
  { label: '🇸🇰 +421', value: '+421', country: 'Slovakia', isoCode: 'sk' },
  { label: '🇸🇮 +386', value: '+386', country: 'Slovenia', isoCode: 'si' },
  {
    label: '🇸🇧 +677',
    value: '+677',
    country: 'Solomon Islands',
    isoCode: 'sb',
  },
  { label: '🇸🇴 +252', value: '+252', country: 'Somalia', isoCode: 'so' },
  { label: '🇿🇦 +27', value: '+27', country: 'South Africa', isoCode: 'za' },
  {
    label: '🇬🇸 +500',
    value: '+500-GS',
    country: 'South Georgia',
    isoCode: 'gs',
  },
  { label: '🇪🇸 +34', value: '+34', country: 'Spain', isoCode: 'es' },
  { label: '🇱🇰 +94', value: '+94', country: 'Sri Lanka', isoCode: 'lk' },
  { label: '🇸🇩 +249', value: '+249', country: 'Sudan', isoCode: 'sd' },
  { label: '🇸🇷 +597', value: '+597', country: 'Suriname', isoCode: 'sr' },
  {
    label: '🇸🇯 +47',
    value: '+47-SJ',
    country: 'Svalbard and Jan Mayen',
    isoCode: 'sj',
  },
  { label: '🇸🇿 +268', value: '+268', country: 'Swaziland', isoCode: 'sz' },
  { label: '🇸🇪 +46', value: '+46', country: 'Sweden', isoCode: 'se' },
  { label: '🇨🇭 +41', value: '+41', country: 'Switzerland', isoCode: 'ch' },
  { label: '🇸🇾 +963', value: '+963', country: 'Syria', isoCode: 'sy' },
  { label: '🇹🇼 +886', value: '+886', country: 'Taiwan', isoCode: 'tw' },
  { label: '🇹🇯 +992', value: '+992', country: 'Tajikistan', isoCode: 'tj' },
  { label: '🇹🇿 +255', value: '+255', country: 'Tanzania', isoCode: 'tz' },
  { label: '🇹🇭 +66', value: '+66', country: 'Thailand', isoCode: 'th' },
  { label: '🇹🇱 +670', value: '+670', country: 'Timor-Leste', isoCode: 'tl' },
  { label: '🇹🇬 +228', value: '+228', country: 'Togo', isoCode: 'tg' },
  { label: '🇹🇰 +690', value: '+690', country: 'Tokelau', isoCode: 'tk' },
  { label: '🇹🇴 +676', value: '+676', country: 'Tonga', isoCode: 'to' },
  {
    label: '🇹🇹 +1-868',
    value: '+1-868',
    country: 'Trinidad and Tobago',
    isoCode: 'tt',
  },
  { label: '🇹🇳 +216', value: '+216', country: 'Tunisia', isoCode: 'tn' },
  { label: '🇹🇷 +90', value: '+90', country: 'Turkey', isoCode: 'tr' },
  { label: '🇹🇲 +993', value: '+993', country: 'Turkmenistan', isoCode: 'tm' },
  {
    label: '🇹🇨 +1-649',
    value: '+1-649',
    country: 'Turks and Caicos Islands',
    isoCode: 'tc',
  },
  { label: '🇹🇻 +688', value: '+688', country: 'Tuvalu', isoCode: 'tv' },
  { label: '🇺🇬 +256', value: '+256', country: 'Uganda', isoCode: 'ug' },
  { label: '🇺🇦 +380', value: '+380', country: 'Ukraine', isoCode: 'ua' },
  {
    label: '🇦🇪 +971',
    value: '+971',
    country: 'United Arab Emirates',
    isoCode: 'ae',
  },
  { label: '🇬🇧 +44', value: '+44', country: 'United Kingdom', isoCode: 'gb' },
  { label: '🇺🇸 +1', value: '+1', country: 'United States', isoCode: 'us' },
  { label: '🇺🇾 +598', value: '+598', country: 'Uruguay', isoCode: 'uy' },
  { label: '🇺🇿 +998', value: '+998', country: 'Uzbekistan', isoCode: 'uz' },
  { label: '🇻🇺 +678', value: '+678', country: 'Vanuatu', isoCode: 'vu' },
  { label: '🇻🇦 +39', value: '+39-VA', country: 'Vatican', isoCode: 'va' },
  { label: '🇻🇪 +58', value: '+58', country: 'Venezuela', isoCode: 've' },
  { label: '🇻🇳 +84', value: '+84', country: 'Vietnam', isoCode: 'vn' },
  {
    label: '🇻🇬 +1-284',
    value: '+1-284',
    country: 'Virgin Islands (British)',
    isoCode: 'vg',
  },
  {
    label: '🇺🇸 +1-340',
    value: '+1-340',
    country: 'Virgin Islands (US)',
    isoCode: 'vi',
  },
  {
    label: '🇼🇫 +681',
    value: '+681',
    country: 'Wallis and Futuna',
    isoCode: 'wf',
  },
  {
    label: '🇪🇭 +212',
    value: '+212-EH',
    country: 'Western Sahara',
    isoCode: 'eh',
  },
  { label: '🇾🇪 +967', value: '+967', country: 'Yemen', isoCode: 'ye' },
  { label: '🇿🇲 +260', value: '+260', country: 'Zambia', isoCode: 'zm' },
  { label: '🇿🇼 +263', value: '+263', country: 'Zimbabwe', isoCode: 'zw' },
];
